/**
 * Resolves a display name for a component instance (for data-component-name attribute).
 */
function getComponentName(instance: {
  $options: { name?: string; __name?: string; __file?: string }
}): string {
  const opts = instance.$options
  if (opts.name) return opts.name
  if ((opts as { __name?: string }).__name) return (opts as { __name?: string }).__name as string
  if (opts.__file) {
    const basename = opts.__file.split('/').pop() ?? ''
    return basename.replace(/\.(vue|js|ts)x?$/i, '') || 'AnonymousComponent'
  }
  return 'AnonymousComponent'
}

/**
 * Mixin that sets data-component-name on each component's root element
 * so components are easy to locate in the DOM (e.g. for testing or debugging).
 */
export const componentNameMixin = {
  mounted(this: { $el: Element | null; $options: { name?: string; __name?: string; __file?: string } }) {
    const el = this.$el
    if (el && typeof (el as Element).setAttribute === 'function') {
      (el as Element).setAttribute('data-component-name', getComponentName(this))
    }
  }
}
